import React from 'react';
import { type TFunction } from 'i18next';

import { TestSessionStatus, TestSessionSummaryDTOAiAnalysisStatus } from '@/api/generated';
import ShieldStatusAttentionIcon from '@/assets/icons/shield-status-attention.svg?react';
import ShieldStatusFailedIcon from '@/assets/icons/shield-status-failed.svg?react';
import ShieldStatusPassedIcon from '@/assets/icons/shield-status-passed.svg?react';
import { IndicatorChipVariant } from '@/components/statuses/IndicatorChip';
import CompletedStatusIcon from '@/components/statuses/TalentStatus/assets/status-completed.svg?react';
import InTestStatusIcon from '@/components/statuses/TalentStatus/assets/status-in-test.svg?react';
import NoAccessStatusIcon from '@/components/statuses/TalentStatus/assets/status-noaccess.svg?react';
import ReTestStatusIcon from '@/components/statuses/TalentStatus/assets/status-re-test.svg?react';
import RegisteredStatusIcon from '@/components/statuses/TalentStatus/assets/status-registered.svg?react';

export const TEST_SESSION_STATUSES = [
  {
    label: (t: TFunction) => t('filters.options.talentStatus.reTest'),
    value: TestSessionStatus.RE_TEST,
    Icon: () => <ReTestStatusIcon />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.noAccess'),
    value: TestSessionStatus.REFUSED,
    Icon: () => <NoAccessStatusIcon />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.registered'),
    value: TestSessionStatus.REGISTERED,
    Icon: () => <RegisteredStatusIcon />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.inTest'),
    value: TestSessionStatus.IN_PROGRESS,
    Icon: () => <InTestStatusIcon />
  },
  {
    label: (t: TFunction) => t('filters.options.talentStatus.completed'),
    value: TestSessionStatus.COMPLETED,
    Icon: () => <CompletedStatusIcon />
  }
] as IndicatorChipVariant[];

export const AI_ANALYSIS_STATUSES = [
  {
    value: TestSessionSummaryDTOAiAnalysisStatus.FAIL,
    Icon: () => <ShieldStatusFailedIcon />
  },
  {
    value: TestSessionSummaryDTOAiAnalysisStatus.PASS,
    Icon: () => <ShieldStatusPassedIcon />
  },
  {
    value: TestSessionSummaryDTOAiAnalysisStatus.INSPECTION_NEEDED,
    Icon: () => <ShieldStatusAttentionIcon />
  }
] as IndicatorChipVariant[];
